import { render, staticRenderFns } from "./SerumIngredientsDetailsSection.vue?vue&type=template&id=76f40aa6&scoped=true&"
import script from "./SerumIngredientsDetailsSection.vue?vue&type=script&lang=js&"
export * from "./SerumIngredientsDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./SerumIngredientsDetailsSection.vue?vue&type=style&index=0&id=76f40aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f40aa6",
  null
  
)

export default component.exports